"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-use-before-define */
const autocompleteselect_form_1 = __importDefault(require("./autocompleteselect.form"));
const Field_1 = __importDefault(require("../../_classes/field/Field"));
const lodash_1 = __importDefault(require("lodash"));
//import dxTagBox from 'devextreme/ui/tag_box';
// import component from '../../templates/bootstrap/component';
// import { debug } from 'webpack';
// import AriForm from '../../../AriForm';
/**
 * Here we will derive from the base component which all Ari.Form form components derive from.
 * @param component
 * @param options
 * @param data
 * @class
 */
class AutoCompleteSelectComponent extends Field_1.default {
    constructor(component, options, data) {
        super(component, options, data);
        this.autoCompleteSelectWhenClickOutSide = (event) => {
            const parentDiv = this.refs[`${this.component.key}-container-auto-complete-select`];
            if (parentDiv) {
                if (!parentDiv.contains(event.target)) {
                    this.refs[`${this.component.key}-valueAutoCompleteSelect`].nextElementSibling.classList.remove('d-block');
                    document.removeEventListener('click', this.autoCompleteSelectWhenClickOutSide);
                }
            }
        };
        this.dataName = '';
        this.dataOpions = [];
        this.selectItemArr = [];
        this.debouncedFunction = lodash_1.default.debounce((v) => {
            if (v.length < 3) {
                this.refs[`${this.component.key}-valueAutoCompleteSelect`].nextElementSibling.querySelector('.auto-complete-list').innerHTML = this.renderNoResult();
                return;
            }
            var args = this.evalContext(args);
            const body = this.component.aribody;
            const aribodyForSearch = body.map((value) => {
                if (value.path === this.component.keyForSearch) {
                    value.value = v;
                }
                if (value.key === this.component.KeyId) {
                    value.value = '';
                }
                return value;
            });
            this.refs[`${this.component.key}-valueAutoCompleteSelect`].nextElementSibling.querySelector('.auto-complete-list').innerHTML = this.renderLoading();
            this.emit('requestAri', {
                com: this.component,
                url: this.interpolate(this.component.aricallselect),
                aribody: aribodyForSearch,
                resultType: null,
                script: (result) => {
                    if (result.length > 0) {
                        this.dataOpions = result;
                        this.refs[`${this.component.key}-valueAutoCompleteSelect`].nextElementSibling.querySelector('.auto-complete-list').innerHTML = this.renderSelect(result);
                    }
                    else {
                        this.refs[`${this.component.key}-valueAutoCompleteSelect`].nextElementSibling.querySelector('.auto-complete-list').innerHTML = this.renderNoResult();
                    }
                    this.addEventClickOption();
                },
                args: args
            });
        }, 1000);
    }
    static schema(...extend) {
        return Field_1.default.schema({
            type: 'autoCompleteSelect',
            label: 'Auto Complete Select',
            dataSrc: 'aripost',
            dataSourcePath: 'dataSource',
            defaultRulePath: 'rule',
            displayInfo: true,
            defaultRule: '',
            formulaDataSource: '',
            align: 'justify-content-start',
            action: 'event'
        }, ...extend);
    }
    get defaultSchema() {
        return AutoCompleteSelectComponent.schema();
    }
    get emptyValue() {
        return this.getValue();
    }
    get inputInfo() {
        const info = super.inputInfo;
        return info;
    }
    get selectItem() {
        const selectItem = this.selectItemArr;
        return selectItem;
    }
    render() {
        var view = `<div  ref="${this.component.key}-container-auto-complete-select" class="container-auto-complete-select">
            <div id="autocomplete-list" class="autocomplete-items choices" data-type="select-one">
            <div id="${this.component.key}-valueAutoCompleteSelect" ref="${this.component.key}-valueAutoCompleteSelect" class="auto-complete-value w-full form-control ${this.component.disabled ? 'is-disabled' : ''} ${this.dataName ? '' : 'placeholder'} ">${this.dataName ? this.dataName : this.component.placeholder}
            <button ref="${this.component.key}-remove-data-auto-complete-select" type="button" class="!ari-focus:shadow-transparent choices__button ari-hidden">Remove item</button>
            </div>
            <div id="${this.component.key}-input-search-wrapper"  class="input-search-wrapper choices__list--dropdown is-active d-none">
                ${this.renderInput()}
                <div class="auto-complete-list ">
                        ${this.renderNoResult()}
                </div>
            </div>
            </div>
        </div>`;
        return super.render(view);
    }
    renderLoading() {
        return '<div class="auto-select-loading p-3"><i class="fa fa-refresh" aria-hidden="true"></i></div>';
    }
    renderNoResult() {
        return `
        <div class="p-3">
            No data to show
        </div>
        `;
    }
    convertTemplate(data, v) {
        // const regex = /\{\{(.*?)\}\}/g;
        const htmlString = data.replace(/\{\{(\w+)\}\}/g, (match, key) => {
            return v[key] || match;
        });
        const textString = htmlString.replace(/<\/?[^>]+(>|$)/g, '');
        return {
            html: htmlString,
            text: textString
        };
    }
    renderSelectItem(options) {
        return options.map((value) => {
            var _a, _b;
            return `<div ref="${this.component.key}-itemAutoCompleteSelect" class="choices__item choices__item--choice item-select-auto-complete choices__item--selectable " data-value="${value[this.component.idPath]}" data-name="${(_a = this.convertTemplate(this.component.template, value)) === null || _a === void 0 ? void 0 : _a.text}">
                ${(_b = this.convertTemplate(this.component.template, value)) === null || _b === void 0 ? void 0 : _b.html}
            </div>`;
        });
    }
    renderSelect(options) {
        var select = `
            <div class="selection dropdown choices__list">
                ${this.renderSelectItem(options).join('')}
            </div>
            `;
        return select;
    }
    renderInput() {
        const info = super.elementInfo();
        info.type = 'input';
        info.ref = `${this.component.key}-builderAutoCompleteSelect`;
        info.changeEvent = 'change';
        info.attr.id = `${this.component.key}-auto-conmplete-select`;
        info.attr.class = 'shadow-none form-control choices__input choices__input--cloned';
        info.component.placeholder = 'Type to search';
        return this.renderTemplate('input', {
            input: info
        });
    }
    setDataName(value) {
        this.dataName = value;
    }
    setValue(value, flags = {}) {
        super.setValue(value, flags);
    }
    getValue() {
        return this.value;
    }
    addEventClickOption() {
        document.querySelectorAll('.item-select-auto-complete').forEach(v => {
            v.addEventListener('click', () => {
                const dataValue = v.getAttribute('data-value');
                const valueToBind = this.dataOpions.find((v) => v[this.component.idPath] === dataValue);
                const name = v.getAttribute('data-name');
                this.refs[`${this.component.key}-valueAutoCompleteSelect`].nextElementSibling.classList.remove('d-block');
                this.setDataName(name);
                this.bindData(valueToBind, true);
                document.removeEventListener('click', this.autoCompleteSelectWhenClickOutSide);
            });
        });
    }
    bindData(value, type) {
        if (type) {
            this.setValue(value);
            this.redraw();
        }
        else {
            const body = this.component.aribody;
            const aribodyForSearch = body.map((v) => {
                if (v.value === this.component.key) {
                    v.value = value;
                }
                return v;
            });
            var args = this.evalContext(args);
            this.emit('requestAri', {
                com: this.component,
                url: this.interpolate(this.component.aricallselect),
                aribody: aribodyForSearch,
                resultType: null,
                script: (result) => {
                    var _a;
                    this.dataOpions = result;
                    const name = (_a = this.convertTemplate(this.component.template, result[0])) === null || _a === void 0 ? void 0 : _a.text;
                    this.setDataName(name);
                    const valueToBind = result.find((v) => v[this.component.idPath] === value);
                    this.setValue(valueToBind);
                    this.redraw();
                },
                args: args
            });
        }
        this.refs[`${this.component.key}-remove-data-auto-complete-select`].classList.remove('ari-hidden');
        this.addEventListener(this.refs[`${this.component.key}-remove-data-auto-complete-select`], 'click', this.clearValue.bind(this));
    }
    clearValue() {
        this.setValue('');
        this.setDataName('');
        this.redraw();
        this.refs[`${this.component.key}-remove-data-auto-complete-select`].classList.add('ari-hidden');
        this.addEventListener(this.refs[`${this.component.key}-remove-data-auto-complete-select`], 'click', this.clearValue.bind(this));
    }
    /**
     * After the html string has been mounted into the dom, the dom element is returned here. Use refs to find specific
     * elements to attach functionality to.
     * @param element
     * @returns {Promise}
     */
    attach(element) {
        var refs = {};
        refs[`${this.component.key}-builderAutoCompleteSelect`] = 'single';
        refs[`${this.component.key}-valueAutoCompleteSelect`] = 'single';
        refs[`${this.component.key}-container-auto-complete-select`] = 'single';
        refs[`${this.component.key}-remove-data-auto-complete-select`] = 'single';
        this.loadRefs(element, refs);
        if (!this.component.disabled) {
            this.addEventListener(this.refs[`${this.component.key}-valueAutoCompleteSelect`], 'click', () => {
                if (this.dataOpions.length > 0) {
                    this.refs[`${this.component.key}-valueAutoCompleteSelect`].nextElementSibling.querySelector('.auto-complete-list').innerHTML = this.renderSelect(this.dataOpions);
                    this.addEventClickOption();
                }
                this.refs[`${this.component.key}-valueAutoCompleteSelect`].nextElementSibling.classList.toggle('d-block');
                // Sử dụng bind để giữ ngữ cảnh của `this`
                document.addEventListener('click', this.autoCompleteSelectWhenClickOutSide.bind(this));
            });
            this.addEventListener(this.refs[`${this.component.key}-builderAutoCompleteSelect`], 'input', (e) => {
                this.debouncedFunction(e.target.value);
            });
        }
        // Allow basic component functionality to attach like field logic and tooltips.
        return super.attach(element);
    }
    updateValue(...args) {
        return this.updateComponentValue(...args);
    }
}
AutoCompleteSelectComponent.editForm = autocompleteselect_form_1.default;
AutoCompleteSelectComponent.builderInfo = {
    title: 'Auto Complete Select',
    group: 'advanced',
    icon: 'caret-square-o-down',
    weight: 70,
    documentation: 'http://help.ari.form/userguide/',
    schema: AutoCompleteSelectComponent.schema()
};
exports.default = AutoCompleteSelectComponent;
